import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const Guard = () => {
  const user  = useSelector((state) => state.root.user);
  const loadingAuth = useSelector((state) => state.root.loadingAuth);

  if (loadingAuth) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/auth/signin" replace />;
  }

  return <Outlet />;
};

export default Guard;
